var map = {
	"./antiepidemicPeople.png": "sKvQ",
	"./atLogo.png": "WgSh",
	"./communityReporting.png": "xOXn",
	"./data_head1.png": "D0nT",
	"./detectionPoint.png": "/Uu4",
	"./epidemicInformation.png": "iacd",
	"./function_person.png": "rAPd",
	"./function_point.png": "2CYL",
	"./function_post.png": "GMPl",
	"./function_testing.png": "Bw6C",
	"./function_yard.png": "JW1m",
	"./left_image.png": "xRXx",
	"./login_bg.png": "9LSc",
	"./logo.png": "Vpqn",
	"./logo@2x.png": "2Lwn",
	"./nav_cost.png": "sgdX",
	"./nav_feedback.png": "bAzC",
	"./nav_home.png": "n2AG",
	"./nav_household.png": "OLiJ",
	"./nav_manage.png": "JQKw",
	"./nav_notice.png": "eoob",
	"./nav_questionnaire.png": "J1U3",
	"./nav_sub_account.png": "akJQ",
	"./nav_sub_budget.png": "EvzE",
	"./nav_sub_collection.png": "e4YM",
	"./nav_sub_item.png": "QpC+",
	"./nav_sub_pay.png": "XFh5",
	"./panghu.png": "jgU6",
	"./play.png": "QaeE",
	"./reportRoommate.png": "VVVt",
	"./riskArea.png": "KkwC",
	"./showpic1.png": "t0Wh",
	"./showpic2.png": "leqR",
	"./showpic3.png": "/UCc",
	"./siderbar_bg.png": "L2/O",
	"./static_bg1.png": "8X2P",
	"./static_bg2.png": "OSCF",
	"./static_bg3.png": "8WCB",
	"./static_bg4.png": "hRlv",
	"./weixin.png": "hCXm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mMHY";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\.png$
// module id = mMHY
// module chunks = 37